export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '751d728', dateTime: 1772738815634 };